// extracted by mini-css-extract-plugin
export default {"label":"text_label__RkVBr","input":"text_input__jl7qi","prefix":"text_prefix__dqwlv","fieldWrap":"text_fieldWrap__lwSDH"};